import AppliesToField from '../fields/AppliesToField';
import ColorField from '../fields/ColorField';
import DateRangeField from '../fields/DateRangeField';
import NameField from '../fields/NameField';
import { TabContentStyled } from '../SeasonalRuleAddEditModal.styles';

const PropertyDetailsTab = () => (
  <TabContentStyled data-testid="seasonal-rule-modal-property-details">
    <NameField />
    <ColorField />
    <DateRangeField />
    <AppliesToField />
  </TabContentStyled>
);

export default PropertyDetailsTab;
